module.exports = __webpack_public_path__ + "img/yy.fa32f8bc.webp";